/* eslint-disable max-len */
import { declensionFactory } from '@app/helpers/declension';

const declinationReviews = declensionFactory('отзыв', 'отзыва', 'отзывов');

const iconStar = `
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
<path d="M9.99935 14.393L15.1493 17.5013L13.7827 11.643L18.3327 7.7013L12.341 7.19297L9.99935 1.66797L7.65768 7.19297L1.66602 7.7013L6.21602 11.643L4.84935 17.5013L9.99935 14.393Z" fill="#FF9900"/>
</svg>
`;

export const Rating = (rating: string, reviews: number): string => {
  if (!rating || !reviews) {
    return '';
  }
  if (rating && reviews) {
    return `<div class="balloon__rating_wrapper">
        ${iconStar}
        <div class="balloon__rating_rating">${rating}</div>
        <div class="balloon__rating_reviews">(${reviews} ${declinationReviews(reviews)})</div>
      </div>`;
  }
};
